import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translate } from 'react-localize-redux';
import { translateText } from '../../utils';
import { HelpLabel, InlineField } from '../controls';
import css from './AdvancedSettings.css';
import { DEEP_LINK_TEXT_MAX_LENGTH, deepLinkRequirementsUrl } from './constants';
import { sitePropType, validationErrorsPropType } from './propTypes';

const IOSDeepLinksSection = ({ site, singularLinksEnabled, readOnly, translate, validationErrors, onSitePatch }) => (
    <section className={classNames(css.formSection, css.iosDeepLinkSection)}>
        <h4>
            <Translate id="STATIC.PAGES.APPS_CONFIGURATION.IOS_UNIVERSAL_LINKS" />
        </h4>
        <div className={css.richText}>
            {translate(
                'STATIC.PAGES.APPS_CONFIGURATION.IOS_DEEP_LINKING_DESCRIPTION',
                { requirementsUrl: deepLinkRequirementsUrl },
                { renderInnerHtml: true }
            )}
        </div>
        <div className={classNames(css.formGridStacked, css.iosDeepLinkFields)}>
            <InlineField
                label={
                    <HelpLabel
                        id="STATIC.PAGES.APPS_CONFIGURATION.TEAM_ID"
                        tooltip="STATIC.PAGES.APPS_CONFIGURATION.TEAM_ID_TOOLTIP"
                    />
                }
                value={site.ios_universal_link_team_id}
                placeholder={translateText(translate, 'STATIC.PAGES.APPS_CONFIGURATION.PLACEHOLDERS.OPTIONAL')}
                disabled={readOnly}
                maxLength={DEEP_LINK_TEXT_MAX_LENGTH}
                onChange={value => onSitePatch({ ios_universal_link_team_id: value })}
            />
            <InlineField
                label={
                    <HelpLabel
                        id="STATIC.PAGES.APPS_CONFIGURATION.IOS_APP_SCHEME"
                        tooltip="STATIC.PAGES.APPS_CONFIGURATION.IOS_APP_SCHEME_TOOLTIP"
                    />
                }
                value={site.app_scheme}
                placeholder={translateText(translate, 'STATIC.PAGES.APPS_CONFIGURATION.PLACEHOLDERS.OPTIONAL')}
                disabled={readOnly}
                maxLength={DEEP_LINK_TEXT_MAX_LENGTH}
                onChange={value => onSitePatch({ app_scheme: value })}
            />
            {!singularLinksEnabled && (
                <InlineField
                    label={<Translate id="STATIC.PAGES.APPS_CONFIGURATION.DOMAIN_NAME_PREFIX" />}
                    value={site.ios_universal_link_subdomain || site._local_ios_universal_link_subdomain}
                    disabled={readOnly || !!site.ios_universal_link_subdomain}
                    error={validationErrors.ios_universal_link_subdomain}
                    onChange={value => onSitePatch({ _local_ios_universal_link_subdomain: value })}
                />
            )}
        </div>
    </section>
);

IOSDeepLinksSection.propTypes = {
    onSitePatch: PropTypes.func.isRequired,
    readOnly: PropTypes.bool.isRequired,
    singularLinksEnabled: PropTypes.bool.isRequired,
    site: sitePropType.isRequired,
    translate: PropTypes.func.isRequired,
    validationErrors: validationErrorsPropType.isRequired,
};

export default IOSDeepLinksSection;
